/**
 * Reading Progress — barra fina no topo que acompanha o scroll do artigo.
 * Ativa apenas quando existe um #post-single na página. Sem dependências.
 */
(function () {
    function init() {
        var article = document.getElementById("post-single");
        var bar = document.querySelector(".reading-progress > span");
        if (!article || !bar) return;

        var ticking = false;

        function update() {
            var rect = article.getBoundingClientRect();
            var viewport = window.innerHeight || document.documentElement.clientHeight;
            // total percorrível: do topo do artigo até seu fim sair da viewport
            var total = article.offsetHeight - viewport;
            var scrolled = -rect.top;
            var pct = total > 0 ? (scrolled / total) * 100 : 0;
            if (pct < 0) pct = 0;
            if (pct > 100) pct = 100;
            bar.style.width = pct + "%";
            ticking = false;
        }

        function onScroll() {
            if (!ticking) {
                window.requestAnimationFrame(update);
                ticking = true;
            }
        }

        window.addEventListener("scroll", onScroll, { passive: true });
        window.addEventListener("resize", onScroll, { passive: true });
        update();
    }

    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", init);
    } else {
        init();
    }
})();
